// extracted by mini-css-extract-plugin
module.exports = {"container":"NH-z","copyContainer":"OH-z"};